module.exports = __webpack_public_path__ + "static/media/estilosos_feminino_ate_200.fe9ed84f.jpg";